// MainPage.js
import React, { useState } from 'react';
import './aviso_legal.css'; // Add custom styles for the main content
import { useTranslation } from 'react-i18next';

const AvisoLegal = () => {
    const { t, i18n } = useTranslation('aviso_legal');

    return (
        <main className="main-content">
            {/* Main Section */}
            <section className="dosier">
                <div className="dosier__image">
                    <img src={`${process.env.PUBLIC_URL}/images/Imagen-7-scaled.jpg`} alt="logo" />
                    <div className="dosier__image__text"><span>{t('aviso_legal_tittle')}</span></div> 
                </div>
            </section>

            <section className="aviso_legal__info">
                <div className="aviso_legal__info__box">
                    <span>
                        {t('aviso_legal_1')}<br></br><br></br>{t('aviso_legal_2')}
                    </span>
                </div>
            </section>
        </main>
    );
};

export default AvisoLegal;
